const r = {
  // All starhub domains
  "http://localhost:3006": { carrier: "starhub", type: "device_protection", env: "local" },
  // For local Portal
  "http://localhost:3007": { carrier: "starhub", type: "repair", env: "local" },
  // For local Portal
  "http://localhost:3008": {
    carrier: "starhub",
    type: "shared",
    env: "local",
    sharedTypes: ["device_protection", "repair"]
  },
  // For local Portal
  "http://localhost:3106": { carrier: "starhub", type: "device_protection", env: "local" },
  // For local Shared
  "http://localhost:3107": { carrier: "starhub", type: "repair", env: "local" },
  // For local Shared
  "http://localhost:3108": {
    carrier: "starhub",
    type: "shared",
    env: "local",
    sharedTypes: ["device_protection", "repair"]
  },
  // For local auth
  "http://localhost:3206": { carrier: "starhub", type: "device_protection", env: "local" },
  // For local Auth
  "http://localhost:3207": { carrier: "starhub", type: "repair", env: "local" },
  // For local Auth
  "http://localhost:3208": {
    carrier: "starhub",
    type: "shared",
    env: "local",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://seahzn-myasurion2-dev.apac.nonprod-asurion53.com": {
    carrier: "starhub",
    type: "device_protection",
    env: "dev"
  },
  "https://seahzn-myasurion2-sqa.apac.nonprod-asurion53.com": {
    carrier: "starhub",
    type: "device_protection",
    env: "sqa"
  },
  "https://seahzn-myasurion2-uat.apac.asurion53.com": {
    carrier: "starhub",
    type: "device_protection",
    env: "uat"
  },
  "https://starhub-dp-myasurion-dev.apac.nonprod-asurion53.com": {
    carrier: "starhub",
    type: "device_protection",
    env: "dev",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://starhub-dp-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "starhub",
    type: "device_protection",
    env: "sqa",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://starhub-dp-myasurion-sqa-stage.apac.nonprod-asurion53.com": {
    carrier: "starhub",
    type: "device_protection",
    env: "sqa-stage",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://starhub-dp-myasurion-uat.apac.asurion53.com": {
    carrier: "starhub",
    type: "device_protection",
    env: "uat",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://smartsupport-care-green.apac.asurion53.com": {
    carrier: "starhub",
    type: "device_protection",
    env: "prodgreen",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://smartsupport-care.starhub.com": {
    carrier: "starhub",
    type: "device_protection",
    env: "prod",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://smartsupport-care.apac.asurion53.com": {
    carrier: "starhub",
    type: "device_protection",
    env: "prod",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://starhub-repair-myasurion-dev.apac.nonprod-asurion53.com": {
    carrier: "starhub",
    type: "repair",
    env: "dev",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://starhub-repair-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "starhub",
    type: "repair",
    env: "sqa",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://starhub-repair-myasurion-sqa-stage.apac.nonprod-asurion53.com": {
    carrier: "starhub",
    type: "repair",
    env: "sqa-stage",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://starhub-repair-myasurion-uat.apac.asurion53.com": {
    carrier: "starhub",
    type: "repair",
    env: "uat",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://smartsupport-repair-green.apac.asurion53.com": {
    carrier: "starhub",
    type: "repair",
    env: "prodgreen",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://smartsupport-repair.starhub.com": {
    carrier: "starhub",
    type: "repair",
    env: "prod",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://smartsupport-repair.apac.asurion53.com": {
    carrier: "starhub",
    type: "repair",
    env: "prod",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://starhub-portal-myasurion-dev.apac.nonprod-asurion53.com": {
    carrier: "starhub",
    type: "shared",
    env: "dev",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://starhub-portal-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "starhub",
    type: "shared",
    env: "sqa",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://starhub-portal-myasurion-sqa-stage.apac.nonprod-asurion53.com": {
    carrier: "starhub",
    type: "shared",
    env: "sqa-stage",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://starhub4-portal-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "starhub",
    carrierForChat: "starhub4",
    type: "shared",
    env: "sqa-demo",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://starhub-portal-myasurion-uat.apac.asurion53.com": {
    carrier: "starhub",
    type: "shared",
    env: "uat",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://smartsupport-portal-green.apac.asurion53.com": {
    carrier: "starhub",
    type: "shared",
    env: "prodgreen",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://smartsupport-portal.starhub.com": {
    carrier: "starhub",
    type: "shared",
    env: "prod",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://smartsupport-portal.apac.asurion53.com": {
    carrier: "starhub",
    type: "shared",
    env: "prod",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://starhub-sqa.myasurion2.apac.nonprod-asurion53.com": {
    carrier: "starhub",
    type: "device_protection",
    env: "sqa",
    isDemo: !0
  },
  "https://starhub-uat.myasurion2.apac.asurion53.com": {
    carrier: "starhub",
    type: "device_protection",
    env: "uat",
    isDemo: !0
  },
  "https://starhub4-dp-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "starhub",
    carrierForChat: "starhub4",
    type: "device_protection",
    env: "sqa-demo",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://starhub4-repair-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "starhub",
    carrierForChat: "starhub4",
    type: "repair",
    env: "sqa-demo",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://starhub4-dp-myasurion-uat.apac.asurion53.com": {
    carrier: "starhub",
    carrierForChat: "starhub4",
    type: "device_protection",
    env: "uat-demo",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://starhub4-repair-myasurion-uat.apac.asurion53.com": {
    carrier: "starhub",
    carrierForChat: "starhub4",
    type: "repair",
    env: "uat-demo",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://starhub4-portal-myasurion-uat.apac.asurion53.com": {
    carrier: "starhub",
    carrierForChat: "starhub4",
    type: "shared",
    env: "uat-demo",
    sharedTypes: ["device_protection", "repair"]
  },
  // All tom (asurion_techcare) domains
  "http://localhost:6006": {
    carrier: "asurion_techcare",
    type: "device_protection",
    env: "local"
  },
  // For local Portal dp
  "http://localhost:6007": { carrier: "asurion_techcare", type: "repair", env: "local" },
  // For local Portal repair
  "http://localhost:6106": {
    carrier: "asurion_techcare",
    type: "device_protection",
    env: "local"
  },
  // For local shared dp
  "http://localhost:6107": {
    carrier: "asurion_techcare",
    type: "repair",
    env: "local"
  },
  // For local shared repair
  "https://tom-myasurion-dev.apac.nonprod-asurion53.com": {
    carrier: "asurion_techcare",
    type: "device_protection",
    env: "dev"
  },
  "https://tom-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "asurion_techcare",
    type: "device_protection",
    env: "sqa"
  },
  "https://tom-myasurion-uat.apac.asurion53.com": {
    carrier: "asurion_techcare",
    type: "device_protection",
    env: "uat"
  },
  "https://tom-repair-myasurion-dev.apac.nonprod-asurion53.com": {
    carrier: "asurion_techcare",
    type: "repair",
    env: "dev"
  },
  "https://tom-repair-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "asurion_techcare",
    type: "repair",
    env: "sqa"
  },
  "https://tom-repair-myasurion-uat.apac.asurion53.com": {
    carrier: "asurion_techcare",
    type: "repair",
    env: "uat"
  },
  "https://my-techcare.apac.asurion53.com": {
    carrier: "asurion_techcare",
    type: "device_protection",
    env: "prodgreen"
  },
  "https://my.asurion.co.th": {
    carrier: "asurion_techcare",
    type: "device_protection",
    env: "prod"
  },
  "https://my-repair-techcare.apac.asurion53.com": {
    carrier: "asurion_techcare",
    type: "repair",
    env: "prodgreen"
  },
  "https://my-repair.asurion.co.th": {
    carrier: "asurion_techcare",
    type: "repair",
    env: "prod"
  },
  "https://repair.asurion.co.th": {
    carrier: "asurion_techcare",
    type: "repair",
    env: "prod"
  },
  "https://techcare-sqa.myasurion2.apac.nonprod-asurion53.com": {
    carrier: "asurion_techcare",
    type: "device_protection",
    env: "sqa",
    isDemo: !0
  },
  "https://techcare-uat.myasurion2.apac.asurion53.com": {
    carrier: "asurion_techcare",
    type: "device_protection",
    env: "uat",
    isDemo: !0
  },
  // All maxis domains
  "http://localhost:3016": { carrier: "maxis", type: "device_protection", env: "local" },
  // For local Portal dp
  "http://localhost:3017": { carrier: "maxis", type: "repair", env: "local" },
  // For local Portal repair
  "http://localhost:3116": { carrier: "maxis", type: "device_protection", env: "local" },
  // For local shared dp
  "http://localhost:3117": { carrier: "maxis", type: "repair", env: "local" },
  // For local shared repair
  "https://maxis-myasurion-dev.apac.nonprod-asurion53.com": {
    carrier: "maxis",
    type: "device_protection",
    env: "dev"
  },
  "https://maxis-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "maxis",
    type: "device_protection",
    env: "sqa"
  },
  "https://maxis-myasurion-uat.apac.asurion53.com": {
    carrier: "maxis",
    type: "device_protection",
    env: "uat"
  },
  "https://maxis-repair-myasurion-dev.apac.nonprod-asurion53.com": {
    carrier: "maxis",
    type: "repair",
    env: "dev"
  },
  "https://maxis-repair-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "maxis",
    type: "repair",
    env: "sqa"
  },
  "https://maxis-repair-myasurion-uat.apac.asurion53.com": {
    carrier: "maxis",
    type: "repair",
    env: "uat"
  },
  "https://maxisdp-prod.apac.asurion53.com": {
    carrier: "maxis",
    type: "device_protection",
    env: "prodgreen"
  },
  "https://maxisdp.asurion.com.my": {
    carrier: "maxis",
    type: "device_protection",
    env: "prod"
  },
  "https://maxis-repair-prod.apac.asurion53.com": {
    carrier: "maxis",
    type: "repair",
    env: "prodgreen"
  },
  "https://maxis-repair.asurion.com.my": {
    carrier: "maxis",
    type: "repair",
    env: "prod"
  },
  "https://maxis-uat.myasurion2.apac.asurion53.com": {
    carrier: "maxis",
    type: "device_protection",
    env: "uat",
    isDemo: !0
  },
  "http://localhost:4006": { carrier: "asurion", type: "device_protection", env: "local" },
  "http://localhost:5006": { carrier: "true", type: "device_protection", env: "local" },
  "http://localhost:7006": { carrier: "celcom", type: "device_protection", env: "local" },
  "http://localhost:8006": { carrier: "umobile", type: "device_protection", env: "local" },
  "http://localhost:9006": { carrier: "lazada", type: "device_protection", env: "local" },
  "http://localhost:9016": { carrier: "smart", type: "device_protection", env: "local" },
  "http://localhost:4106": { carrier: "asurion", type: "device_protection", env: "local" },
  "http://localhost:5106": { carrier: "true", type: "device_protection", env: "local" },
  "http://localhost:7106": { carrier: "celcom", type: "device_protection", env: "local" },
  "http://localhost:8106": { carrier: "umobile", type: "device_protection", env: "local" },
  "http://localhost:9106": { carrier: "lazada", type: "device_protection", env: "local" },
  "http://localhost:9116": { carrier: "smart", type: "device_protection", env: "local" },
  "http://localhost:9506": { carrier: "demo1", type: "device_protection", env: "local" },
  "http://localhost:9606": { carrier: "demo1", type: "device_protection", env: "local" },
  "http://localhost:7117": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "local"
  },
  "http://localhost:7118": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "local"
  },
  "https://asurion-sqa.myasurion2.apac.nonprod-asurion53.com": {
    carrier: "asurion",
    type: "device_protection",
    env: "sqa"
  },
  "https://true-sqa.myasurion2.apac.nonprod-asurion53.com": {
    carrier: "true",
    type: "device_protection",
    env: "sqa"
  },
  "https://celcom-sqa.myasurion2.apac.nonprod-asurion53.com": {
    carrier: "celcom",
    type: "device_protection",
    env: "sqa"
  },
  "https://umobile-sqa.myasurion2.apac.nonprod-asurion53.com": {
    carrier: "umobile",
    type: "device_protection",
    env: "sqa"
  },
  "https://lazada-th-sqa.myasurion2.apac.nonprod-asurion53.com": {
    carrier: "lazada",
    type: "device_protection",
    env: "sqa"
  },
  "https://smart-ph-sqa.myasurion2.apac.nonprod-asurion53.com": {
    carrier: "smart",
    type: "device_protection",
    env: "sqa",
    isDemo: !0
  },
  "https://true-uat.myasurion2.apac.asurion53.com": {
    carrier: "true",
    type: "device_protection",
    env: "uat"
  },
  "https://asurion-uat.myasurion2.apac.asurion53.com": {
    carrier: "asurion",
    type: "device_protection",
    env: "uat"
  },
  "https://celcom-uat.myasurion2.apac.asurion53.com": {
    carrier: "celcom",
    type: "device_protection",
    env: "uat"
  },
  "https://umobile-uat.myasurion2.apac.asurion53.com": {
    carrier: "umobile",
    type: "device_protection",
    env: "uat"
  },
  "https://lazada-th-uat.myasurion2.apac.asurion53.com": {
    carrier: "lazada",
    type: "device_protection",
    env: "uat"
  },
  "https://smart-ph-uat.myasurion2.apac.asurion53.com": {
    carrier: "smart",
    type: "device_protection",
    env: "uat",
    isDemo: !0
  },
  "https://demo1.myasurion2.apac.asurion53.com": {
    carrier: "demo1",
    type: "device_protection",
    env: "uat"
  },
  "https://synnex-ews-myasurion-dev.apac.nonprod-asurion53.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "dev"
  },
  "https://synnex-ews-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "sqa"
  },
  "https://synnex-ews-myasurion-uat.apac.asurion53.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "uat"
  },
  "https://sinya.asurion.com.tw": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "prod"
  },
  "https://sinya-green.apac.asurion53.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "prod"
  },
  // All cht/senao domains
  "http://localhost:4016": { carrier: "cht_home", type: "device_protection", env: "local" },
  // For local Portal dp
  "http://localhost:4017": { carrier: "cht_home", type: "repair", env: "local" },
  // For local Portal repair
  "http://localhost:4116": { carrier: "cht_home", type: "device_protection", env: "local" },
  // For local shared dp
  "http://localhost:4117": { carrier: "cht_home", type: "repair", env: "local" },
  // For local shared repair
  "https://cht-home-myasurion-dev.apac.nonprod-asurion53.com": {
    carrier: "cht_home",
    type: "device_protection",
    env: "dev"
  },
  "https://cht-home-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "cht_home",
    type: "device_protection",
    env: "sqa"
  },
  "https://cht-home-myasurion-uat.apac.asurion53.com": {
    carrier: "cht_home",
    type: "device_protection",
    env: "uat"
  },
  "https://cht-home-myasurion-prodgreen.apac.asurion53.com": {
    carrier: "cht_home",
    type: "device_protection",
    env: "prodgreen"
  },
  "https://homeplus-cht.asurion.com.tw": {
    carrier: "cht_home",
    type: "device_protection",
    env: "prod"
  },
  // 'https://cht-home-repair-myasurion-dev.apac.nonprod-asurion53.com': {
  //     carrier: 'cht_home',
  //     type: 'repair',
  //     env: 'dev',
  // },
  // 'https://cht-home-repair-myasurion-sqa.apac.nonprod-asurion53.com': {
  //     carrier: 'cht_home',
  //     type: 'repair',
  //     env: 'sqa',
  // },
  // 'https://cht-home-repair-myasurion-uat.apac.asurion53.com': {
  //     carrier: 'cht_home',
  //     type: 'repair',
  //     env: 'uat',
  // },
  // All jbhifi/senao domains
  "http://localhost:8016": { carrier: "jbhifi", type: "device_protection", env: "local" },
  // For local Portal dp
  "http://localhost:8017": { carrier: "jbhifi", type: "repair", env: "local" },
  // For local Portal repair
  "http://localhost:8018": { carrier: "jbhifi", type: "device_protection", env: "local" },
  // For local shared dp
  "http://localhost:8019": { carrier: "jbhifi", type: "repair", env: "local" },
  // For local shared repair
  // 'https://jb-complete-myasurion-sqa.apac.nonprod-asurion53.com': {
  //     carrier: 'jbhifi',
  //     type: 'device_protection',
  //     env: 'dev',
  // },
  "https://jb-complete-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "jbhifi",
    type: "device_protection",
    env: "sqa"
  },
  "https://jb-complete-uat-blue.apac.asurion53.com": {
    carrier: "jbhifi",
    type: "device_protection",
    env: "uat"
  },
  // 'https://cht-home-myasurion-uat.apac.asurion53.com': {
  //     carrier: 'jbhifi',
  //     type: 'device_protection',
  //     env: 'uat',
  // },
  // 'https://cht-home-myasurion-prodgreen.apac.asurion53.com': {
  //     carrier: 'jbhifi',
  //     type: 'device_protection',
  //     env: 'prodgreen',
  // },
  // For local Portal dp
  "http://localhost:8020": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "local",
    hasRetailer: !0,
    configName: "twopenmarket_ty3c",
    retailerName: "TY3C",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "http://localhost:8021": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "local",
    hasRetailer: !0,
    configName: "twopenmarket_yicheng",
    retailerName: "YICHENG",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "http://localhost:8022": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "local",
    hasRetailer: !0,
    configName: "twopenmarket_liyen",
    retailerName: "LIYEN",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "http://localhost:8023": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "local",
    hasRetailer: !0,
    configName: "twopenmarket_zhengzhe",
    retailerName: "ZHENGZHE",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "http://localhost:8024": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_onion",
    retailerName: "ONION",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "http://localhost:8025": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_jyes",
    retailerName: "JYES",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "http://localhost:8026": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_qek888",
    retailerName: "QEK888",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "http://localhost:8027": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_navy3c",
    retailerName: "NAVY3C",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "http://localhost:8028": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_money3c",
    retailerName: "MONEY3C",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "http://localhost:8029": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_miko3c",
    retailerName: "MIKO3C",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "http://localhost:8030": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_1101",
    retailerName: "1101",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "http://localhost:8031": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_01phone",
    retailerName: "01PHONE",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "http://localhost:8032": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_jason",
    retailerName: "JASON",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "http://localhost:8033": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_xinxin",
    retailerName: "XINXIN",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "https://warranty-sqa.apac.nonprod-asurion53.com": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "sqa"
  },
  "https://ty3c-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_ty3c",
    retailerName: "TY3C",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "https://liyen-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_liyen",
    retailerName: "LIYEN",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "https://zhengzhe-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_zhengzhe",
    retailerName: "ZHENGZHE",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "https://onion-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_onion",
    retailerName: "ONION",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "https://yicheng-warranty-sqa.apac.nonprod-asurion53.com": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_yicheng",
    retailerName: "YICHENG",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "https://jyes-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_jyes",
    retailerName: "JYES",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "https://qek888-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_qek888",
    retailerName: "QEK888",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "https://navy3c-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_navy3c",
    retailerName: "NAVY3C",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "https://money3c-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_money3c",
    retailerName: "MONEY3C",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "https://miko3c-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_miko3c",
    retailerName: "MIKO3C",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "https://1101-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_1101",
    retailerName: "1101",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "https://01phone-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_01phone",
    retailerName: "01PHONE",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "https://jason-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_jason",
    retailerName: "JASON",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "https://xinxin-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_xinxin",
    retailerName: "XINXIN",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "https://ty3c-myasurion-uat.apac.asurion53.com": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "uat",
    hasRetailer: !0,
    configName: "twopenmarket_ty3c",
    retailerName: "TY3C",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "https://liyen-myasurion-uat.apac.asurion53.com": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "uat",
    hasRetailer: !0,
    configName: "twopenmarket_liyen",
    retailerName: "LIYEN",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "https://zhengzhe-myasurion-uat.apac.asurion53.com": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "uat",
    hasRetailer: !0,
    configName: "twopenmarket_zhengzhe",
    retailerName: "ZHENGZHE",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "https://onion-myasurion-uat.apac.asurion53.com": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "uat",
    hasRetailer: !0,
    configName: "twopenmarket_onion",
    retailerName: "ONION",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "https://yicheng-myasurion-uat.apac.asurion53.com": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "uat",
    hasRetailer: !0,
    configName: "twopenmarket_yicheng",
    retailerName: "YICHENG",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "https://jyes-myasurion-uat.apac.asurion53.com": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "uat",
    hasRetailer: !0,
    configName: "twopenmarket_jyes",
    retailerName: "JYES",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "https://qek888-myasurion-uat.apac.asurion53.com": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "uat",
    hasRetailer: !0,
    configName: "twopenmarket_qek888",
    retailerName: "QEK888",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "https://navy3c-myasurion-uat.apac.asurion53.com": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "uat",
    hasRetailer: !0,
    configName: "twopenmarket_navy3c",
    retailerName: "NAVY3C",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "https://money3c-myasurion-uat.apac.asurion53.com": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "uat",
    hasRetailer: !0,
    configName: "twopenmarket_money3c",
    retailerName: "MONEY3C",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "https://miko3c-myasurion-uat.apac.asurion53.com": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "uat",
    hasRetailer: !0,
    configName: "twopenmarket_miko3c",
    retailerName: "MIKO3C",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "https://1101-myasurion-uat.apac.asurion53.com": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "uat",
    hasRetailer: !0,
    configName: "twopenmarket_1101",
    retailerName: "1101",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "https://01phone-myasurion-uat.apac.asurion53.com": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "uat",
    hasRetailer: !0,
    configName: "twopenmarket_01phone",
    retailerName: "01PHONE",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "https://jason-myasurion-uat.apac.asurion53.com": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "uat",
    hasRetailer: !0,
    configName: "twopenmarket_jason",
    retailerName: "JASOM",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "https://xinxin-myasurion-uat.apac.asurion53.com": {
    carrier: "twopenmarket_slw",
    type: "device_protection",
    env: "uat",
    hasRetailer: !0,
    configName: "twopenmarket_xinxin",
    retailerName: "XINXIN",
    retailerFileFolderName: "twopenmarket_slw"
  },
  "http://localhost:7119": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "local",
    hasRetailer: !0,
    configName: "twopenmarket_pchome",
    retailerName: "PCHOMEESD",
    retailerFileFolderName: "twopenmarket_retailer"
  },
  "http://localhost:7120": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "local",
    hasRetailer: !0,
    configName: "twopenmarket_yahoo",
    retailerName: "YAHOOESD",
    retailerFileFolderName: "twopenmarket_retailer"
  },
  "http://localhost:7121": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "local",
    hasRetailer: !0,
    configName: "twopenmarket_elifemall",
    retailerName: "ELIFE",
    retailerFileFolderName: "twopenmarket_retailer"
  },
  "http://localhost:7122": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "local",
    hasRetailer: !0,
    configName: "twopenmarket_liwen",
    retailerName: "LIWEN",
    retailerFileFolderName: "twopenmarket_retailer"
  },
  "http://localhost:7123": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "local",
    hasRetailer: !0,
    configName: "twopenmarket_yourlink",
    retailerName: "YOURLINK",
    retailerFileFolderName: "twopenmarket_retailer"
  },
  "http://localhost:7124": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "local",
    hasRetailer: !0,
    configName: "twopenmarket_momo",
    retailerName: "MOMO",
    retailerFileFolderName: "twopenmarket_retailer"
  },
  "http://localhost:7125": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "local",
    hasRetailer: !0,
    configName: "twopenmarket_first",
    retailerName: "FIRST",
    retailerFileFolderName: "twopenmarket_retailer"
  },
  "https://synnex-ews-laptop-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_ews",
    retailerName: "Sinya",
    retailerFileFolderName: "twopenmarket_retailer"
  },
  "https://yahoo-ews-laptop-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_yahoo",
    retailerName: "YAHOOESD",
    retailerFileFolderName: "twopenmarket_retailer"
  },
  "https://pchome-ews-laptop-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_pchome",
    retailerName: "PCHOMEESD",
    retailerFileFolderName: "twopenmarket_retailer"
  },
  "https://elifemall-ews-laptop-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_elifemall",
    retailerName: "ELIFE",
    retailerFileFolderName: "twopenmarket_retailer"
  },
  "https://liwen-ews-laptop-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_liwen",
    retailerName: "LIWEN",
    retailerFileFolderName: "twopenmarket_retailer"
  },
  "https://yourlink-ews-laptop-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_yourlink",
    retailerName: "YOURLINK",
    retailerFileFolderName: "twopenmarket_retailer"
  },
  "https://momo-ews-laptop-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_momo",
    retailerName: "MOMO",
    retailerFileFolderName: "twopenmarket_retailer"
  },
  "https://first-ews-laptop-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "sqa",
    hasRetailer: !0,
    configName: "twopenmarket_first",
    retailerName: "FIRST",
    retailerFileFolderName: "twopenmarket_retailer"
  },
  "https://yh-ews-myasurion-uat.apac.asurion53.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "uat",
    hasRetailer: !0,
    configName: "twopenmarket_yahoo",
    retailerName: "YAHOOESD",
    retailerFileFolderName: "twopenmarket_retailer"
  },
  "https://pchome-ews-myasurion-uat.apac.asurion53.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "uat",
    hasRetailer: !0,
    configName: "twopenmarket_pchome",
    retailerName: "PCHOMEESD",
    retailerFileFolderName: "twopenmarket_retailer"
  },
  "https://elifemall-ews-myasurion-uat.apac.asurion53.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "uat",
    hasRetailer: !0,
    configName: "twopenmarket_elifemall",
    retailerName: "ELIFE",
    retailerFileFolderName: "twopenmarket_retailer"
  },
  "https://liwen-ews-myasurion-uat.apac.asurion53.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "uat",
    hasRetailer: !0,
    configName: "twopenmarket_liwen",
    retailerName: "LIWEN",
    retailerFileFolderName: "twopenmarket_retailer"
  },
  "https://yourlink-ews-myasurion-uat.apac.asurion53.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "uat",
    hasRetailer: !0,
    configName: "twopenmarket_yourlink",
    retailerName: "YOURLINK",
    retailerFileFolderName: "twopenmarket_retailer"
  },
  "https://momo-ews-myasurion-uat.apac.asurion53.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "uat",
    hasRetailer: !0,
    configName: "twopenmarket_momo",
    retailerName: "MOMO",
    retailerFileFolderName: "twopenmarket_retailer"
  },
  "https://first-ews-myasurion-uat.apac.asurion53.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "uat",
    hasRetailer: !0,
    configName: "twopenmarket_first",
    retailerName: "FIRST",
    retailerFileFolderName: "twopenmarket_retailer"
  },
  "https://yh-warranty.apac.asurion.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "prod",
    hasRetailer: !0,
    configName: "twopenmarket_yahoo",
    retailerName: "YAHOOESD",
    retailerFileFolderName: "twopenmarket_retailer"
  },
  "https://pchome-warranty.apac.asurion.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "prod",
    hasRetailer: !0,
    configName: "twopenmarket_pchome",
    retailerName: "PCHOMEESD",
    retailerFileFolderName: "twopenmarket_retailer"
  },
  "https://liwen-warranty.apac.asurion.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "prod",
    hasRetailer: !0,
    configName: "twopenmarket_liwen",
    retailerName: "LIWEN",
    retailerFileFolderName: "twopenmarket_retailer"
  },
  "https://elifemall-warranty.apac.asurion.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "prod",
    hasRetailer: !0,
    configName: "twopenmarket_elifemall",
    retailerName: "ELIFE",
    retailerFileFolderName: "twopenmarket_retailer"
  },
  "https://yourlink-warranty.apac.asurion.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "prod",
    hasRetailer: !0,
    configName: "twopenmarket_yourlink",
    retailerName: "YOURLINK",
    retailerFileFolderName: "twopenmarket_retailer"
  },
  "https://momo-warranty.apac.asurion.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "prod",
    hasRetailer: !0,
    configName: "twopenmarket_momo",
    retailerName: "MOMO",
    retailerFileFolderName: "twopenmarket_retailer"
  },
  "https://first-warranty.apac.asurion.com": {
    carrier: "twopenmarket_synnex",
    type: "device_protection",
    env: "prod",
    hasRetailer: !0,
    configName: "twopenmarket_first",
    retailerName: "FIRST",
    retailerFileFolderName: "twopenmarket_retailer"
  },
  //for sh device care chnages
  "http://localhost:4007": { carrier: "sh_device_care", type: "device_protection", env: "local" },
  // For local Portal
  "http://localhost:4008": { carrier: "sh_device_care", type: "repair", env: "local" },
  // For local Portal
  "http://localhost:4009": {
    carrier: "sh_device_care",
    type: "shared",
    env: "local",
    sharedTypes: ["device_protection", "repair"]
  },
  // For local Portal
  "http://localhost:4107": { carrier: "sh_device_care", type: "device_protection", env: "local" },
  // For local Shared
  "http://localhost:4108": { carrier: "sh_device_care", type: "repair", env: "local" },
  // For local Shared
  "http://localhost:4109": {
    carrier: "sh_device_care",
    type: "shared",
    env: "local",
    sharedTypes: ["device_protection", "repair"]
  },
  // For local auth
  "http://localhost:4207": { carrier: "sh_device_care", type: "device_protection", env: "local" },
  // For local Auth
  "http://localhost:4208": { carrier: "sh_device_care", type: "repair", env: "local" },
  // For local Auth
  "http://localhost:4209": {
    carrier: "sh_device_care",
    type: "shared",
    env: "local",
    sharedTypes: ["device_protection", "repair"]
  },
  // For CelcomDigi DP
  "https://celcom-dp-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "celcom",
    type: "device_protection",
    env: "sqa",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://celcom-dp-myasurion-uat.apac.asurion53.com": {
    carrier: "celcom",
    type: "device_protection",
    env: "uat",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://phonecare-login.asurion.com": {
    carrier: "celcom",
    type: "device_protection",
    env: "prod",
    sharedTypes: ["device_protection", "repair"]
  },
  // For CelcomDigi Repair
  "https://celcom-repair-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "celcom",
    type: "repair",
    env: "sqa",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://celcom-repair-myasurion-uat.apac.asurion53.com": {
    carrier: "celcom",
    type: "repair",
    env: "uat",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://service2u-login.asurion.com": {
    carrier: "celcom",
    type: "repair",
    env: "prod",
    sharedTypes: ["device_protection", "repair"]
  },
  // For CelcomDigi Shared
  "https://celcom-portal-myasurion-sqa.apac.nonprod-asurion53.com": {
    carrier: "celcom",
    type: "shared",
    env: "sqa",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://celcom-portal-myasurion-uat.apac.asurion53.com": {
    carrier: "celcom",
    type: "shared",
    env: "uat",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://phonecare-portal.asurion.com": {
    carrier: "celcom",
    type: "shared",
    env: "prod",
    sharedTypes: ["device_protection", "repair"]
  },
  // For celecomDigi local auth
  "http://localhost:3077": { carrier: "celcom", type: "device_protection", env: "local" },
  "http://localhost:3078": { carrier: "celcom", type: "repair", env: "local" },
  "http://localhost:3079": {
    carrier: "celcom",
    type: "shared",
    env: "local",
    sharedTypes: ["device_protection", "repair"]
  },
  // All m1 domains
  "http://localhost:9020": { carrier: "m1", type: "device_protection", env: "local" },
  // For local Portal
  "http://localhost:9021": { carrier: "m1", type: "repair", env: "local" },
  // For local Portal
  "http://localhost:9022": {
    carrier: "m1",
    type: "shared",
    env: "local",
    sharedTypes: ["device_protection", "repair"]
  },
  // For local Portal
  "http://localhost:9120": { carrier: "m1", type: "device_protection", env: "local" },
  // For local Shared
  "http://localhost:9121": { carrier: "m1", type: "repair", env: "local" },
  // For local Shared
  "http://localhost:9122": {
    carrier: "m1",
    type: "shared",
    env: "local",
    sharedTypes: ["device_protection", "repair"]
  },
  // For local auth
  "http://localhost:9220": { carrier: "m1", type: "device_protection", env: "local" },
  // For local Auth
  "http://localhost:9221": { carrier: "m1", type: "repair", env: "local" },
  // For local Auth
  "http://localhost:9222": {
    carrier: "m1",
    type: "shared",
    env: "local",
    sharedTypes: ["device_protection", "repair"]
  },
  "https://m1bizcare-dev.apac.nonprod-asurion53.com": {
    carrier: "m1",
    type: "device_protection",
    env: "dev",
    configName: "m1"
  },
  "https://m1bizcare-sqa.apac.nonprod-asurion53.com": {
    carrier: "m1",
    type: "device_protection",
    env: "sqa",
    configName: "m1"
  }
}, s = () => {
  var e;
  return ((e = r[window.location.origin]) == null ? void 0 : e.carrier) || "asurion";
}, l = () => {
  var e;
  return ((e = r[window.location.origin]) == null ? void 0 : e.carrierForChat) || null;
}, m = () => {
  var e;
  return ((e = r[window.location.origin]) == null ? void 0 : e.type) || "device_protection";
}, h = () => {
  var e;
  return ((e = r[window.location.origin]) == null ? void 0 : e.env) || "dev";
}, u = () => {
  var e;
  return ((e = r[window.location.origin]) == null ? void 0 : e.sharedTypes) || "device_protection";
}, d = (e, n, p, c) => {
  var t, o, i;
  for (const a in r)
    if (r[a].carrier === e && r[a].type === n && r[a].env === p && ((t = r[a]) == null ? void 0 : t.isDemo) === void 0) {
      if (c && (!((o = r[a]) != null && o.sharedTypes) || ((i = r[a]) == null ? void 0 : i.sharedTypes) === void 0))
        continue;
      return a;
    }
}, y = () => {
  var e;
  return ((e = r[window.location.origin]) == null ? void 0 : e.hasRetailer) || !1;
}, v = () => {
  var e;
  return ((e = r[window.location.origin]) == null ? void 0 : e.configName) || "";
}, _ = () => {
  var e;
  return ((e = r[window.location.origin]) == null ? void 0 : e.retailerName) || "";
}, w = () => {
  var e;
  return ((e = r[window.location.origin]) == null ? void 0 : e.retailerFileFolderName) || "";
};
export {
  m as a,
  l as b,
  u as c,
  d,
  h as e,
  _ as f,
  s as g,
  y as h,
  v as i,
  w as j
};
